var _path, _path2, _path3, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaiIcHelpmono(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9117 17C12.5086 17 12.9065 16.6 12.9065 16C12.9065 15.4 12.5086 15 11.9117 15C11.3149 15 10.917 15.4 10.917 16C10.917 16.6 11.3149 17 11.9117 17Z",
    fill: "#2B45D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8896 12C20.8896 7 16.9107 3 11.937 3C6.96332 3 2.98438 7 2.98438 12C2.98438 17 6.96332 21 11.937 21C16.9107 21 20.8896 17 20.8896 12ZM4.97385 12C4.97385 8.1 8.05753 5 11.937 5C15.8165 5 18.9002 8.1 18.9002 12C18.9002 15.9 15.8165 19 11.937 19C8.05753 19 4.97385 15.9 4.97385 12Z",
    fill: "#2B45D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12C13.1047 12 14.0001 11.1046 14.0001 10C14.0001 8.89543 13.1047 8 12.0001 8C11.4439 8 10.9407 8.22709 10.5781 8.59362",
    stroke: "#2B45D4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 13,
    stroke: "#2B45D4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiIcHelpmono);
export default __webpack_public_path__ + "static/media/mai-ic-help.mono.132b005d6b6a56f9c1244e2d367d630f.svg";
export { ForwardRef as ReactComponent };